import React from "react";
import SharedDonut from "../../common/DonutChart";
import { BRAND, STATUS_COLORS, getPaletteColor } from "../../../utils/chartTheme";

const DonutChartWithSideData = ({ data, centerValue, centerLabel }) => {
  const allStatusData = [
    {
      name: "Completed",
      value: data?.completedFeatures || 0,
      color: STATUS_COLORS.completed,
    },
    {
      name: "Pending",
      value: data?.pendingFeatures || 0,
      color: STATUS_COLORS.planned,
    },
    {
      name: "Monitored",
      value: data?.monitoredFeaturesCount || 0,
      color: BRAND.teal,
    },
    {
      name: "Not Monitored",
      value: Math.max(
        0,
        (data?.totalBOQs || 0) - (data?.monitoredFeaturesCount || 0)
      ),
      color: getPaletteColor(2),
    },
  ];

  return (
    <SharedDonut
      items={allStatusData}
      centerValue={typeof centerValue === "number" ? centerValue : undefined}
      centerLabel={centerLabel}
    />
  );
};
const MonitoringSummaryChart = ({ data }) => {
  const monitoringData = data?.success ? data.data : data;

  const {
    totalMonitoringRecords = 0,
    completedFeatures = 0,
    totalBOQs = 0,
    monitoredFeaturesCount = 0,
    monitoringCoverageRate = "0",
    averageMonitoringFrequency = "0.00",
  } = monitoringData || {};

  const pendingFeatures = totalBOQs - completedFeatures;
  const notMonitoredFeatures = Math.max(0, totalBOQs - monitoredFeaturesCount);
  const coverageRate = parseFloat(monitoringCoverageRate || 0);

  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <div className="text-center">
        <h3 className="text-lg my-1 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Summary Metrics
        </h3>
      </div>

      <DonutChartWithSideData
        data={{
          completedFeatures,
          pendingFeatures,
          monitoredFeaturesCount,
          totalBOQs,
          notMonitoredFeatures,
        }}
        centerValue={totalBOQs.toLocaleString()}
        centerLabel="Total BOQs"
      />
      <div className="mt-3 grid grid-cols-2 gap-2">
        <div className="text-center p-2 bg-[#E6F2F2] rounded">
          <div className="text-xs text-[#0B5557]">Coverage</div>
          <div className="text-sm font-bold text-[#137E81]">
            {coverageRate.toFixed(1)}%
          </div>
        </div>
        <div className="text-center p-2 bg-[#E6F2F2] rounded">
          <div className="text-xs text-[#0B5557]">Avg Frequency</div>
          <div className="text-sm font-bold text-[#137E81]">
            {parseFloat(averageMonitoringFrequency || 0).toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonitoringSummaryChart;
export { DonutChartWithSideData };
